import { useCallback, useEffect, useState } from "react";

import {
  applyConsent,
  CookieConsentSettings,
  DEFAULT_SETTINGS,
  getStoredConsent,
  OPEN_COOKIE_PREFERENCES_EVENT,
  saveConsent,
} from "@/utils/cookieConsent";

import CookieBanner from "./CookieBanner";
import CookiePreferencesModal from "./CookiePreferencesModal";

const CookieConsent = () => {
  const [settings, setSettings] = useState<CookieConsentSettings>(
    DEFAULT_SETTINGS
  );
  const [bannerOpen, setBannerOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const stored = getStoredConsent();
    if (stored) {
      setSettings(stored);
      applyConsent(stored);
    } else {
      setBannerOpen(true);
    }
  }, []);

  useEffect(() => {
    const handler = () => {
      setModalOpen(true);
    };
    window.addEventListener(OPEN_COOKIE_PREFERENCES_EVENT, handler);
    return () =>
      window.removeEventListener(OPEN_COOKIE_PREFERENCES_EVENT, handler);
  }, []);

  const persist = useCallback(
    (next: { analytics: boolean; marketing: boolean }) => {
      const stored = saveConsent(next);
      setSettings(stored);
      setBannerOpen(false);
      setModalOpen(false);
    },
    []
  );

  const handleAcceptAll = useCallback(() => {
    persist({ analytics: true, marketing: true });
  }, [persist]);

  const handleRejectNonEssential = useCallback(() => {
    persist({ analytics: false, marketing: false });
  }, [persist]);

  const handleCustomize = useCallback(() => {
    setModalOpen(true);
  }, []);

  return (
    <>
      <CookieBanner
        open={bannerOpen && !modalOpen}
        onAcceptAll={handleAcceptAll}
        onRejectNonEssential={handleRejectNonEssential}
        onCustomize={handleCustomize}
        onClose={handleRejectNonEssential}
      />
      <CookiePreferencesModal
        open={modalOpen}
        initialAnalytics={settings.analytics}
        initialMarketing={settings.marketing}
        onClose={() => setModalOpen(false)}
        onSave={persist}
      />
    </>
  );
};

export default CookieConsent;
